export default __webpack_public_path__ + "18082b6c3f30086e370b68572a216fe6.png";